import {
  AGENCY_CONTEXT_STORAGE_KEY,
  AGENCY_INFO_STORAGE_KEY,
  GOOGLE_AUTH_COOKIE_KEY,
  LAST_FETCH_STORAGE_KEY,
  LOGIN_STORAGE_KEY,
  RETURN_URL_STORAGE_KEY,
  USER_CONTEXT_STORAGE_KEY,
  USER_PIC_STORAGE_KEY,
  USER_PRIVILEGES_STORAGE_KEY,
  USER_SIGN_OFF_STORAGE_KEY,
  USER_STORAGE_KEY,
} from "constants"
import { AUTH_TOKEN_COOKIE_KEY } from "constants/api"
import { LOGIN_PATH } from "constants/app-paths"
import { getCookie, removeCookie } from "utils/cookie"
import { inDevelopMode } from "utils/env"
import { getStorageItem, removeStorageItem, setStorageItem } from "utils/localStorage"

export const getAppCredentials = () => {
  const token = getCookie(AUTH_TOKEN_COOKIE_KEY) // HTTP Only
  const privileges = getStorageItem(USER_PRIVILEGES_STORAGE_KEY)
  const isLoggedIn = getStorageItem(LOGIN_STORAGE_KEY)
  const info = getStorageItem(USER_STORAGE_KEY)
  // const language = getAppLanguage()
  const language = {}
  console.log(isLoggedIn, "isLoggedIn")
  return {
    auth: { token, isLoggedIn: isLoggedIn === "no" ? false : !!isLoggedIn },
    // auth: { token, isLoggedIn: false },
    configs: {
      ...language,
      direction: language?.rtl ? "rtl" : "ltr",
      locale: language.key || "en",
      // screenSize: { width: window?.innerWidth, height: window?.innerHeight },
    },
    user: info ? { info } : {},
  }
}

export const removeAppCredentials = (saveUrl, reload) => {
  saveUrl &&
    !inDevelopMode &&
    !window.location.pathname.includes(LOGIN_PATH) &&
    setStorageItem(RETURN_URL_STORAGE_KEY, window.location.href)
  removeCookie(AUTH_TOKEN_COOKIE_KEY)
  removeCookie(GOOGLE_AUTH_COOKIE_KEY)
  removeStorageItem(LOGIN_STORAGE_KEY)
  removeStorageItem(USER_STORAGE_KEY)
  removeStorageItem(USER_PRIVILEGES_STORAGE_KEY)
  removeStorageItem(USER_CONTEXT_STORAGE_KEY)
  removeStorageItem(USER_PIC_STORAGE_KEY)
  removeStorageItem(USER_SIGN_OFF_STORAGE_KEY)
  removeStorageItem(AGENCY_CONTEXT_STORAGE_KEY)
  removeStorageItem(AGENCY_INFO_STORAGE_KEY)
  removeStorageItem(LAST_FETCH_STORAGE_KEY)
  reload && window.location.reload()
}
export const getBrowserName = () => {
  const ua = navigator.userAgent
  if (ua.includes("Opera") || ua.includes("OPR")) {
    return "Opera"
  } else if (ua.includes("Edg")) {
    return "Microsoft Edge"
  } else if (ua.includes("Chrome") && !ua.includes("Chromium")) {
    return "Chrome"
  } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
    return "Safari"
  } else if (ua.includes("Firefox")) {
    return "Firefox"
  } else if (ua.includes("MSIE") || ua.includes("Trident")) {
    return "Internet Explorer"
  } else {
    return false
  }
}

const getUserOS = () => {
  const userAgent = navigator.userAgent
  let userOS = ""
  if (userAgent.includes("Windows")) {
    userOS = "windows"
  } else if (userAgent.includes("Macintosh")) {
    userOS = "mac_os"
  } else if (userAgent.includes("Linux")) {
    userOS = "linux"
  } else {
    userOS = "unknown"
  }
  return userOS
}
